import { Stack } from 'expo-router';
import React from 'react';

export default function AuthLayout() {
    // Auth layout is now purely declarative - route protection is handled at root level
    return (
        <Stack screenOptions={{ headerShown: false }} initialRouteName="login">
            <Stack.Screen name="login" options={{ title: 'Login' }} />
            <Stack.Screen name="register" options={{ title: 'Register' }} />
            <Stack.Screen name="verify-otp" options={{ title: 'Verify Email' }} />
            <Stack.Screen name="forgot-password" options={{ title: 'Forgot Password' }} />
            <Stack.Screen name="reset-password" options={{ title: 'Reset Password' }} />
        </Stack>
    );
}
